import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F7CB7031-655F-43BE-9165-F6C2CEC047B4
 * name arrow-bottom-right
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightIcon = createSvgIcon(<><path d="M5,6.41L6.41,5L17,15.59V9H19V19H9V17H15.59L5,6.41Z" /></>, 'ArrowBottomRightIcon');
export default ArrowBottomRightIcon